import { Descriptions } from "antd";

import {
  ApplicantProfileIdentityContainerApplicantUserFieldsFragment,
} from "../../../../generated";
import dayjs from "dayjs";
import React from "react";
import {ProfileIdentityDocumentUploadContainer} from "./profile-identity-document-upload.container";
import { ProfileHeader } from "./profile-header";
import { DATE_FORMAT } from "../../../../constants";
import utc from "dayjs/plugin/utc";
import { DateInformationFooter } from "../../../shared/date-information-footer";

dayjs.extend(utc);
interface IdentityProps {
  data: ApplicantProfileIdentityContainerApplicantUserFieldsFragment;

}

export const ProfileIdentity: React.FC<IdentityProps> = (props) => {
  let genderLabel = "";
  if (props.data.personalInformation?.identityDetails?.gender === "M") {
    genderLabel = "Male";
  } else if (props.data.personalInformation?.identityDetails?.gender === "F") {
    genderLabel = "Female";
  } else {
    genderLabel = "Other";
  }

  return (
    <div className="flex flex-col space-y-4 w-[85%] md:w-auto"
    style={{
      marginBottom: "150px",
    }}
    
    >
      <ProfileHeader title="Identity Details"/>
      <div>
        <Descriptions
          title={undefined}
          layout="vertical"
          size="small"
          column={2}
          className="w-[400px]"
        >
          <Descriptions.Item label="Applicant ID">
            {props.data.id}
          </Descriptions.Item>
          <Descriptions.Item label="">&nbsp;</Descriptions.Item>
          <Descriptions.Item label="Last Name (Surname/Family Name)">
            {props.data.personalInformation?.identityDetails?.lastName}
          </Descriptions.Item>
          <Descriptions.Item label="Rest of Name">
            {props.data.personalInformation?.identityDetails?.restOfName}
          </Descriptions.Item>
          <Descriptions.Item label="Generational Suffix">
            {props.data.personalInformation?.identityDetails?.generationalSuffix ?? "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Gender">{genderLabel}</Descriptions.Item>
          <Descriptions.Item label="Date of Birth">
            {dayjs(props.data.personalInformation?.identityDetails?.dateOfBirth).utc().format(DATE_FORMAT).toUpperCase()}
          </Descriptions.Item>
          <Descriptions.Item label="Email Address">
            {props.data.personalInformation?.contactInformation?.emailAddress}
          </Descriptions.Item>
        </Descriptions>
      </div>
      <ProfileIdentityDocumentUploadContainer/>
      <div className="flex space-x-48">
      <DateInformationFooter
        customStyle={{
          right: 0,
          width: "100%",
          
        }}
      />
    </div>
  </div>
  );
};
